import styled from 'styled-components';

export const MansoryContainer = styled.div`
  margin-bottom: 10px;
  width: 100%;
  word-wrap: break-word;

  :last-child {
    margin-bottom: 40px;
  }

  @media screen and (min-width: 1024px ) {
    width: 32%;
  };

`;

export const MansoryGutter = styled.div`
  width: 0%;

  @media screen and (min-width: 1024px ) {
    width: 2%
  };
`;
